import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("p", null, "写下一篇博客吧")], -1);

const _hoisted_2 = /*#__PURE__*/_createTextVNode("发布");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("发表文章");

const _hoisted_4 = {
  class: "card-header"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("往期文章标题");

const _hoisted_6 = {
  class: "titleTip"
};
const _hoisted_7 = {
  class: "titleDate"
};
import { onMounted, reactive, ref } from "vue";
import { ElDrawer, ElMessage } from "element-plus";
import MdEditor from "md-editor-v3";
import "md-editor-v3/lib/style.css";
import axios from "axios";
import { pub_blog, blogClassTitleList5, blogClassAll } from "@/api/blog.js"; //博客内容

export default {
  __name: 'writeBlog',

  setup(__props) {
    const conten = ref(""); //往期文章卡片状态

    const cardStatus = ref(false); //博客表单

    const form = reactive({
      class: "",
      name: "",
      psd: "",
      text: ""
    });
    const afterTitleList = ref([]); //侧边数据

    const besideTable = ref(false);
    onMounted(() => {
      console.log("写博客挂载完成");
      document.title = '撰写博客';
    }); //上传blog图片

    const onUploadImg = async (files, callback) => {
      const res = await Promise.all(files.map(file => {
        return new Promise((rev, rej) => {
          const form = new FormData();
          form.append("img", file);
          axios.post("https://manage1.hej6666.cn/upload_blog_img", form, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then(res => rev(res)).catch(error => rej(error));
        });
      }));
      callback(res.map(item => item.data.url));
    }; //保存blog


    const onSave = () => {
      console.log("onSave被触发");
      console.log(conten.value);
    }; //自动补全数组


    const restaurants = ref([]); //打开侧边栏

    const besideTableOpen = () => {
      besideTable.value = true;
      console.log("加载自动补全数据");
      blogClassAll().then(res => {
        console.log(res);
        restaurants.value = res.data.data.list;
      }).catch(err => {
        console.log("发生错误了", err);
      });
    }; //自动补全


    const querySearch = (queryString, cb) => {
      const results = queryString ? restaurants.value.filter(createFilter(queryString)) : restaurants.value; // call callback function to return suggestions

      cb(results);
    }; //补全函数


    const createFilter = queryString => {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    }; //手动选择文章分类触发函数


    const handleSelect = item => {
      console.log(item.id);
      form.class = item.value;
      console.log("展示这个分类下之前文章的标题，以供参考");
      cardStatus.value = true;
      getAfterTitleList(item.id);
    }; //改变了文章分类


    const changeClass = value => {
      console.log("改变了文章内容" + value);
      cardStatus.value = false;
    }; //获取指定分类往期文章的标题


    const getAfterTitleList = classId => {
      console.log("请求指定文章分类的往期文章标题" + classId);
      let postData = {
        blogClass: classId
      };
      blogClassTitleList5(postData).then(res => {
        console.log(res);

        if (res.data.code == 200) {
          //按创建时间倒序
          res.data.data.list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); //赋值

          afterTitleList.value = res.data.data.list.map(item => {
            console.log("item", item);
            const date = new Date(item.created_at);
            item.created_at = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + ":" + date.getMinutes();
            return item;
          });
        } else {
          console.log("数据异常");
          ElMessage({
            message: "服务器异常，请稍后重试",
            type: "error"
          });
        }
      });
    }; //发表文章


    const subText = () => {
      form.text = conten.value;
      console.log("数据是", form);

      if (form.class == "" || form.name == "" || form.text == "") {
        return ElMessage({
          message: "文章不完整",
          type: "warning"
        });
      }

      if (form.psd == "") {
        return ElMessage({
          message: "没有暗号是不行的",
          type: "warning"
        });
      }

      let postData = {
        class: form.class,
        name: form.name,
        text: form.text,
        psd: form.psd
      };
      pub_blog(postData).then(res => {
        console.log("发表文章后", res);

        if (res.data.code == 200) {
          return ElMessage({
            message: res.data.message,
            type: "success"
          });
        } else {
          return ElMessage({
            message: res.data.message,
            type: "warning"
          });
        }
      });
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_autocomplete = _resolveComponent("el-autocomplete");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_card = _resolveComponent("el-card");

      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(_unref(MdEditor), {
        modelValue: conten.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => conten.value = $event),
        onOnUploadImg: onUploadImg,
        onOnSave: onSave
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        class: "submit",
        onClick: besideTableOpen
      }, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createVNode(_unref(ElDrawer), {
        modelValue: besideTable.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => besideTable.value = $event),
        title: "发布文章",
        direction: "rtl",
        size: "80%"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "文章分类"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 48
            }, {
              default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
                modelValue: form.class,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.class = $event),
                "fetch-suggestions": querySearch,
                clearable: "",
                class: "inline-input w-150 inputW",
                placeholder: "输入文章分类",
                maxlength: "240",
                "show-word-limit": "",
                type: "text",
                onSelect: handleSelect,
                onChange: changeClass
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "文章标题"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 48
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.name = $event),
                maxlength: "240",
                "show-word-limit": "",
                type: "text",
                class: "inputW"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "发文暗号"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 48
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.psd,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.psd = $event),
                maxlength: "240",
                "show-word-limit": "",
                type: "text",
                class: "inputW"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_el_button, {
          type: "primary",
          class: "psotBtn",
          onClick: subText,
          onTap: subText
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_card, {
          class: "box-card"
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString(form.class), 1), _createVNode(_component_el_button, {
            class: "button",
            text: ""
          }, {
            default: _withCtx(() => [_hoisted_5]),
            _: 1
          })])]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(afterTitleList.value, value => {
            return _openBlock(), _createElementBlock("div", {
              key: value.id,
              class: "text item"
            }, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_6, _toDisplayString(value.title), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(value.created_at), 1)])]);
          }), 128))]),
          _: 1
        })], 512), [[_vShow, cardStatus.value]])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }

};